import { TextField } from '@radix-ui/themes';

export type TextFieldSize = '1' | '2' | '3';

export type TextFieldProps = Omit<TextField.RootProps, 'size' | 'color'> & {
  size?: TextFieldSize;
  iconStart?: React.ReactNode | string;
  iconStartSize?: number;
  iconEnd?: React.ReactNode | string;
  iconEndSize?: number;
  label?: React.ReactNode;
  error?: boolean;
  errorMessage?: React.ReactNode;
  withTooltip?: boolean;
  tooltip?: React.ReactNode;

  parse?: (value: string) => string;
};

export const sizeToFontSize: Record<TextFieldSize, string> = {
  '1': 'text-size-fly-1',
  '2': 'text-size-fly-2',
  '3': 'text-size-fly-3',
};

export const sizeToClassName: Record<TextFieldSize, string> = {
  '1': 'rounded-4',
  '2': 'rounded-5',
  '3': 'rounded-5',
};
